import p from './scheme-library.vue';

export default p;
